export { default } from './AreaChart.js';
